import { computed, Component, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { LocaleService } from '@next/core-lib/i18n';

const PLANT_DATE_WARNING_TRANSLATION_PREFIX = 'shared.plantDateWarnings';

@Component({
  selector: 'app-plant-date-warning',
  standalone: true,
  templateUrl: './plant-date-warning.component.html',
  styleUrl: './plant-date-warning.component.scss',
  imports: [MatTooltip, MatIconButton],
})
export class PlantDateWarningComponent {
  private readonly locale = inject(LocaleService);
  private readonly localeDataChanged = toSignal(this.locale.localeDataChanged$, { initialValue: null });

  readonly warningCodes = input<ReadonlyArray<string>>([]);

  protected readonly warningMessages = computed(() => {
    this.localeDataChanged();

    return this.warningCodes()
      .map((code) => this.locale.translate(`${PLANT_DATE_WARNING_TRANSLATION_PREFIX}.${code}`))
      .filter((message) => !!message);
  });

  protected readonly warningSummary = computed(() => this.warningMessages().join('\n'));
}
